export const SESSION_COOKIE_REGEX = /(?:^|;\s*)ib_sessionid=([^;]*)/;
export const PINCODE_COOKIE_REGEX = /(?:^|;\s*)pincode=([^;]*)/;
export const JWT_COOKIE_REGEX = /(?:^|;\s*)ibx=([^;]*)/;
export const FEEDBACK_SESSION_COOKIE_REGEX = /(?:^|;\s*)ibx-feedback=([^;]*)/;
export const IB_SID_COOKIE_REGEX = /(?:^|;\s*)ib_sid=([^;]*)/;

export function isSSR(): boolean {
  return typeof window === 'undefined';
}

export function getSessionToken(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(SESSION_COOKIE_REGEX);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

export function getPincodeFromCookie(): string {
  if (typeof document === 'undefined') return '';
  const match = document.cookie.match(PINCODE_COOKIE_REGEX);
  return match?.[1] ? decodeURIComponent(match[1]) : '';
}

export function getJwtFromCookie(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(JWT_COOKIE_REGEX);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

export function getIbSidFromCookie(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(IB_SID_COOKIE_REGEX);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

export function setPincodeCookie(pincode: string, maxAgeDays = 90): void {
  if (typeof document === 'undefined') return;
  // Shared across subdomains (e.g. checkout-app on staging.industrybuying.com,
  // checkout-api on stark-staging.industrybuying.com) so the API actually
  // receives it. Omitted on localhost/non-industrybuying hosts, where a
  // leading-dot domain the browser doesn't own would be rejected outright.
  const domain = /(^|\.)industrybuying\.com$/.test(window.location.hostname)
    ? '; domain=.industrybuying.com'
    : '';
  document.cookie = `pincode=${encodeURIComponent(pincode)}; path=/; max-age=${maxAgeDays * 24 * 60 * 60}${domain}`;
}

// Anonymous-user identifier for flows (e.g. FAQ feedback) that need to dedupe
// guest submissions without a logged-in userId or the legacy ib_sessionid
// cookie, which JWT-flow apps like support-app never receive.
export function getOrCreateFeedbackSessionId(maxAgeDays = 365): string | null {
  if (typeof document === 'undefined') return null;

  const match = document.cookie.match(FEEDBACK_SESSION_COOKIE_REGEX);
  if (match?.[1]) return decodeURIComponent(match[1]);

  const id = crypto.randomUUID();
  const domain = /(^|\.)industrybuying\.com$/.test(window.location.hostname)
    ? '; domain=.industrybuying.com'
    : '';
  document.cookie = `ibx-feedback=${encodeURIComponent(id)}; path=/; max-age=${maxAgeDays * 24 * 60 * 60}${domain}`;
  return id;
}
